import { render, staticRenderFns } from "./headItem.vue?vue&type=template&id=620dd02d&scoped=true&"
import script from "./headItem.vue?vue&type=script&lang=js&"
export * from "./headItem.vue?vue&type=script&lang=js&"
import style0 from "./headItem.vue?vue&type=style&index=0&id=620dd02d&prod&style=true&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620dd02d",
  null
  
)

export default component.exports